export default "__VITE_ASSET__$vEAnjv5__"